module.exports = __webpack_public_path__ + "static/media/samsung-internet_256x256.7e5be4e3.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/browser-logos/src/samsung-internet/samsung-internet_256x256.png
// module id = 2868
// module chunks = 0